function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M39.477,32.476a4.941,4.941,0,0,0-3.972,1.652L24.473,28.346V25.868l11.032-5.782a5.766,5.766,0,0,0,3.972,1.652,5.664,5.664,0,0,0,5.737-5.369,5.749,5.749,0,0,0-11.473,0v1.239L22.708,23.39a5.766,5.766,0,0,0-3.972-1.652A5.664,5.664,0,0,0,13,27.107a5.664,5.664,0,0,0,5.737,5.369,4.941,4.941,0,0,0,3.972-1.652l11.032,5.782v1.239a5.749,5.749,0,0,0,11.473,0A5.664,5.664,0,0,0,39.477,32.476Z",
  transform: "translate(-13 -11)",
  fill: "#109dff",
  fillRule: "evenodd"
});

function SvgPictoPartage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.214,
    height: 32.214,
    viewBox: "0 0 32.214 32.214",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoPartage);
export default __webpack_public_path__ + "static/media/picto_partage.6cf5eef0.svg";
export { ForwardRef as ReactComponent };